import { ActionType } from "../../actions/ActionType";
import { Action } from "../../actions/ecSeat/SeatMapActions";

export interface SeatMapState {
    isLoading: boolean;
    error: string | null;
    VenuesLocationList: {
        locationNo: string;
        locationName: string;
    }[];
    VenuesSeatingMap: {
        area: string;
        seatingMap: string;
    }[];
}

const initialState = {
    isLoading: false,
    error: null,
    VenuesLocationList: [],
    VenuesSeatingMap: [],
};


const seatMapReducer = (
    state: SeatMapState = initialState,
    action: Action
) => {
    switch (action.type) {
        case ActionType.FETCH_VENUES_LOCATION_LIST_START:
            return {
                isLoading: true,
                error: null,
                VenuesLocationList: state.VenuesLocationList,
                VenuesSeatingMap: state.VenuesSeatingMap,
            };
        case ActionType.FETCH_VENUES_LOCATION_LIST_SUCCESS:
            return {
                isLoading: false,
                error: null,
                VenuesLocationList: action.payload,
                VenuesSeatingMap: state.VenuesSeatingMap,
            };
        case ActionType.FETCH_VENUES_LOCATION_LIST_ERROR:
            return {
                isLoading: false,
                error: action.payload,
                VenuesLocationList: state.VenuesLocationList,
                VenuesSeatingMap: state.VenuesSeatingMap,
            };
        case ActionType.FETCH_VENUES_SEATING_MAP_START:
            return {
                isLoading: true,
                error: null,
                VenuesLocationList: state.VenuesLocationList,
                VenuesSeatingMap: state.VenuesSeatingMap,
            };
        case ActionType.FETCH_VENUES_SEATING_MAP_SUCCESS:
            return {
                isLoading: false,
                error: null,
                VenuesLocationList: state.VenuesLocationList,
                VenuesSeatingMap: action.payload,
            };
        case ActionType.FETCH_VENUES_SEATING_MAP_ERROR:
            return {
                isLoading: false,
                error: action.payload,
                VenuesLocationList: state.VenuesLocationList,
                VenuesSeatingMap: state.VenuesSeatingMap,
            };
        default:
            return state;
    }
};

export default seatMapReducer;
